import { produce } from 'immer';
import {
    ActiveMilitaryPersonalInfoViewModel,
    FormSelectChoice,
    InactiveMilitaryPersonalInfoViewModel,
    VerificationService,
} from '@sheerid/jslib';

export const updateMilitaryViewModel = (
    key: keyof ActiveMilitaryPersonalInfoViewModel | keyof InactiveMilitaryPersonalInfoViewModel,
    value: any,
    verificationService: VerificationService,
    availableStatuses: FormSelectChoice[],
): ActiveMilitaryPersonalInfoViewModel | InactiveMilitaryPersonalInfoViewModel => {
    const viewModel = verificationService.viewModel as ActiveMilitaryPersonalInfoViewModel;
    const nextState: ActiveMilitaryPersonalInfoViewModel = produce(
        viewModel,
        (draft: ActiveMilitaryPersonalInfoViewModel) => {
            // @ts-expect-error
            (draft[key] as any) = value;
            // If there are no status choices, don't validate
            if (!availableStatuses) {
                draft.fieldsToSkipValidation = ['status'];
            }

            if (key === 'status') {
                draft.organization = {
                    id: 0,
                    name: '',
                };
            }
        },
    );
    return nextState;
};
